const TitleLine = props => {
    return <h2 className={["title-line", props.className].join(" ")}><span></span><span>{props.children}</span><span></span></h2>
}

export default TitleLine;